<nav *ngIf="includeTableOfContent">
    <h3>Table of Contents</h3>
    <ng-container *ngFor="let section of sections">
        <ul *ngIf="section.title">
            <li>
              <em class="icon-locked disabled" *ngIf="!section.sectionContent"></em>
                <em class="empty-space" *ngIf="section.sectionContent"></em>
                <a [attr.href]="createAnchorHref(section.title)" [class.disabled]="!section.sectionContent"
                  (click)="onClick($event, section.title)">{{ section.title }}</a>
            </li>
        </ul>
    </ng-container>
</nav>
